import { GenericValue } from 'hisng';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HisBaseGlobalsService } from 'hisng';
import {
    ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER,
    ENGLISH_DATE_TIME_PIPE_FORMAT,
    GERMAN_DATE_TIME_FORMAT_PLACEHOLDER,
    GERMAN_DATE_TIME_PIPE_FORMAT
} from 'app/rm/erp/common/model/constants';
import { Transportation } from '../../model/transportation';

@Component( {
    selector: 'erp-businesstripapplication-transportation',
    templateUrl: './businesstripapplication-transportation.component.html'
} )
export class BusinesstripApplicationTransportationComponent implements OnInit {
    @Input() transportation: Transportation = new Transportation();
    @Output() readonly transportationChange = new EventEmitter<Transportation>();
    readonly dateTimeFormat: string;
    readonly datePlaceholderFormat: string;

    constructor(
        private readonly hisBaseGlobalsService: HisBaseGlobalsService,
    ) {
        if ( this.hisBaseGlobalsService.getLanguage() === 'de' ) {
            this.dateTimeFormat = GERMAN_DATE_TIME_PIPE_FORMAT;
            this.datePlaceholderFormat = GERMAN_DATE_TIME_FORMAT_PLACEHOLDER;
        } else {
            this.dateTimeFormat = ENGLISH_DATE_TIME_PIPE_FORMAT;
            this.datePlaceholderFormat = ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER;
        }
    }

    ngOnInit(): void {
    }

    onModelChange( changedValue: string | Date | GenericValue ): void {

        if ( !this.transportation.largeMileageAllowance ) {
            this.transportation.largeMileageAllowanceExplanation = undefined;
        }

        if ( !this.transportation.isPrivateTrip ) {
            this.transportation.privateTripBeginDate = undefined;
            this.transportation.privateTripEndDate = undefined;
            this.transportation.privateTripResidence = undefined;
            this.transportation.privateTripAddress = undefined;
            this.transportation.privateTripExplanation = undefined;
        }

        if ( !this.transportation.transportationReservation ) {
            this.transportation.transportationReservationExplanation = undefined;
        }

        if ( !this.transportation.transportationOther ) {
            this.transportation.transportationOtherExplanation = undefined;
        }

        this.transportationChange.emit( this.transportation );
    }
}
